import Image from "next/image";
import { useSearchParams } from "next/navigation";
import { CSSProperties } from "react";

import Breadcumb from "@/components/Breadcumb";
import { getPageRoute, getS3ImageUrl } from "@/utils/routes";
import classes from "./Top.module.css";

import { LeftIcon, RightIcon } from "@/components/Icons";
import { PageWrapperSync as PageWrapper } from "@/components/PageWrapper";
import useProductsFilter, { addQueryPrefix } from "@/hooks/useProductsFilter";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Link from "next/link";

interface Props {
  className?: string;
  style?: CSSProperties;
  category?: CategoryItem;

  onFilter?: (key: string, value: string) => void;
  brands?: BrandItem[];
  breadcrumbs?: { name: string; link?: Link }[];
  widgets?: Widget[];
  subcategories?: CategoryItem[];

  productsFilter: ReturnType<typeof useProductsFilter>;
}

const Top = ({
  className,
  style,
  category,

  onFilter = () => {},

  brands = [],
  breadcrumbs = [],
  widgets = [],

  productsFilter,
  subcategories,
}: Props) => {
  const searchParams = useSearchParams();

  const classNames = [classes.Top, className];

  const randomKey = Math.random().toString(36).substring(7);
  // const randomKey = useMemo(() => Math.random().toString(36).substring(7), [])

  return (
    <div className={classNames.join(" ")} style={style}>
      {/* <div className={classes.filterButtons}>
                <button className={classes.button}>
                    <SortOutlineIcon width={20} height={20} />
                    <p className={classes.label}>
                        Sort
                    </p>
                </button>

                <button className={classes.button}
                    onClick={() => productsFilter.setOpenFilterModal(true)}
                >
                    <FilterOutlineIcon width={20} height={20} />
                    <p className={classes.label}>
                        Filter
                    </p>
                </button>
            </div> */}

      <div className={`${classes.container} container`}>
        {breadcrumbs.length > 0 && (
          <Breadcumb
            items={breadcrumbs.map((b) => ({
              name: b.name,
              link: getPageRoute(
                b.link?.urlType || "custom",
                b.link?.url || ""
              ),
            }))}
          />
        )}
      </div>

      {category && (
        <div className="container mb-2">
          <h1 className="text-primary text-xl mb-1">{category.heading}</h1>
          <p>{category.shortSummary}</p>
        </div>
      )}

      <PageWrapper
        page={
          {
            widgets,
          } as any
        }
      />

      <div className={`${classes.container} container flex gap-2 flex-wrap`}>
        {/* {brands.length > 0 && (
          <div className={classes.brands}>
            <div className={classes.changer}>
              <button
                className={`${classes.button} ${classes.left}`}
                id={"category-page-brand-slider-prev-" + randomKey}
              >
                <LeftIcon className={classes.icon} />
              </button>

              <button
                className={`${classes.button} ${classes.right}`}
                id={"category-page-brand-slider-next-" + randomKey}
              >
                <RightIcon className={classes.icon} />
              </button>
            </div>

            <Swiper
              spaceBetween={8}
              navigation={{
                nextEl: "#category-page-brand-slider-next-" + randomKey,
                prevEl: "#category-page-brand-slider-prev-" + randomKey,
              }}
              slidesPerView={"auto"}
              pagination={{
                clickable: true,
              }}
              className={classes.swiper}
              modules={[Navigation]}
            >
              {brands.map((brand, i) => {
                const active =
                  searchParams.get(addQueryPrefix("brands")) === brand.slug;
                const classNames = `${classes.brand} ${
                  active ? classes.active : ""
                }`;

                return (
                  <SwiperSlide
                    key={brand.id || brand.slug || `brand-${i}`}
                    style={{
                      width: "auto",
                    }}
                  >
                    <button
                      className={classNames}
                      onClick={() =>
                        onFilter("brands", active ? "" : brand.slug)
                      }
                    >
                      {brand.logo && (
                        <Image
                          src={getS3ImageUrl(brand.logo || "")}
                          alt={brand.name || ""}
                          layout="responsive"
                          unoptimized={true}
                          width={20}
                          height={20}
                          style={{
                            objectFit: "contain",
                            maxHeight: "20px",
                            maxWidth: "50px",
                          }}
                        />
                      )}

                      <p className={classes.name}>{brand.name}</p>
                    </button>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        )} */}

        {subcategories &&
          subcategories?.length > 0 &&
          subcategories?.map((categoryItem) => (
            <Link
              key={'cat-link-'+categoryItem.id + "-" + categoryItem.slug + "-link"}
              href={getPageRoute("category", categoryItem.slug)}
              className={`border text-xs md:text-sm px-3 py-1 rounded-full ${
                category?.name === categoryItem.name
                  ? "border-primary text-primary"
                  : "border-gray-300 text-gray3"
              }`}
            >
              {categoryItem.name}
            </Link>
          ))}
      </div>
    </div>
  );
};

export default Top;
